<template lang="html">
  <div class="">
    <div class="LA-input-code">
      <input
        v-for="(char, idx) in code_length"
        :key="idx"
        :ref="`input-${idx}`"
        v-model="dataCode[idx]"
        :data-code="'code' + idx"
        type="text"
        maxlength="1"
        placeholder="•"
        class="input-code-dinein"
        onfocus="this.placeholder = ''"
        onblur="this.placeholder = '•'"
        @keydown="handleKeyDown($event, idx)"
        @keyup="handleKeyUp($event, idx)"
      >
    </div>
    <div class="meesage-error">
      <div v-if="errorMessage || errorMessage !== ''" class="text-center">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      code_length: 6,
      dataCode: []
    }
  },
  watch: {
    dataCode() {
      this.emitInput()
    },
    value: function(newItem, oldItem) {
      if (newItem === '' || newItem === null) {
        this.dataCode = []
      }
    }
  },
  methods: {
    handleKeyDown(e, index) {
      const userAgent = navigator.userAgent.toLowerCase()
      const Android = userAgent.indexOf('android') > -1
      const inputElements = [...document.querySelectorAll('input.input-code-dinein')]
      if (!Android) {
        if (e.keyCode === 8 && e.target.value === '') {
          inputElements[Math.max(0, index - 1)].focus()
          // eslint-disable-next-line
  			} else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {
          const [first, ...rest] = e.target.value
          e.target.value = first || ''
          if (index !== inputElements.length - 1 && first !== undefined) {
            inputElements[index + 1].focus()
            inputElements[index + 1].value = rest.join('')
            inputElements[index + 1].dispatchEvent(new Event('input'))
          }
        }
        this.emitInput()
      }
    },
    handleKeyUp(e, index) {
      const userAgent = navigator.userAgent.toLowerCase()
      const Android = userAgent.indexOf('android') > -1
      if (Android) {
        const inputElements = [...document.querySelectorAll('input.input-code-dinein')]
        var inputCode = document.querySelector('[data-code=code' + index + ']')
        if (inputCode.value.length > 1) {
          inputCode.value = inputCode.value.substring(0, 1)
        }
        const key = _sanitizeEventKey(e.target.value.charAt(e.target.selectionStart - 1).charCodeAt())
        if (isNaN(parseFloat(key)) && index !== 0) {
          inputElements[Math.max(0, index - 1)].focus()
        } else if ((key >= 48 && key <= 57) || (key >= 65 && key <= 90) || (key >= 97 && key <= 122)) {
          const [first, ...rest] = e.target.value
          e.target.value = first || ''
          if (index !== inputElements.length - 1 && first !== undefined) {
            inputElements[index + 1].focus()
            inputElements[index + 1].value = rest.join('')
            inputElements[index + 1].dispatchEvent(new Event('input'))
          }
        }
        this.emitInput()
      }
    },
    emitInput() {
      const result = this.dataCode.join('').slice(0, this.code_length)
      this.$emit('input', result)
    }
  }
}

function _sanitizeEventKey(key) {
  return key === 'Unidentified' ? undefined : key
}
</script>

<style lang="css" scoped>
.LA-input-code > input::-webkit-input-placeholder,
.LA-input-code > input:-ms-input-placeholder,
.LA-input-code > input::placeholder {
  color: #BEBEBE;
  font-size: 24px;
  text-align: center;
}
.LA-input-code > input{
  width: 30px;
  height: 32px;
  text-align: center;
  border: none;
  outline: none;
  font-size: 24px;
  font-weight: bold;
}
.LA-input-code{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 8px;
}
.meesage-error{
  font-size: 12px;
  color: #D70B20;
}
</style>
